import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "width100per" }
const _hoisted_2 = { class: "info-title-bottom" }
const _hoisted_3 = { class: "info-container info-title-bottom" }
const _hoisted_4 = { class: "info-title-bottom" }
const _hoisted_5 = { class: "info-label-title" }
const _hoisted_6 = { class: "info-title-bottom" }
const _hoisted_7 = { class: "info-label-title" }
const _hoisted_8 = { class: "info-title-bottom" }
const _hoisted_9 = { class: "info-label-title" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "clear-float" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "width1000px line" }, null, -1)
const _hoisted_14 = { class: "margin-top20px" }
const _hoisted_15 = { class: "font-size20px" }
const _hoisted_16 = { class: "margin-top20px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _createVNode("b", null, _toDisplayString(_ctx.$wordList.OrderPurchaseDetails), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$wordList.ProperAllTextFeaturePlan), 1),
        _createVNode("label", null, _toDisplayString(_ctx.featureName), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$wordList.ProperAllTextFeeType), 1),
        _createVNode("label", null, _toDisplayString(_ctx.FeeType[_ctx.featureFeeType]), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$wordList.Fee) + "($)", 1),
        _createVNode("label", null, _toDisplayString(_ctx.featurePrice), 1)
      ])
    ]),
    _hoisted_10,
    (_ctx.showMonth)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_el_input_number, {
            modelValue: _ctx.featureCount,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.featureCount = $event)),
            min: 1,
            max: 60,
            class: "margin-right20px width300px margin-top10px"
          }, null, 8, ["modelValue"]),
          _createTextVNode(" " + _toDisplayString(_ctx.$wordList.ProperAllTextMonth) + " ", 1),
          _hoisted_11
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_12,
    _hoisted_13,
    _createVNode("div", _hoisted_14, [
      _createVNode("b", _hoisted_15, " $" + _toDisplayString(_ctx.totalPrice), 1)
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.sureDetail
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootNext), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}